import lazySizes from 'lazysizes'
import { mq_breakpoints } from './breakpoints'

// Lazysizes
lazySizes.cfg.lazyClass = 'lazyload'
lazySizes.cfg.customMedia = {
  ...mq_breakpoints
}
